import styled from 'styled-components';
import { oneOf } from 'prop-types';
import { C_WHITE } from '@bbc/psammead-styles/colours';
import { GEL_SPACING, GEL_SPACING_HLF } from '@bbc/gel-foundations/spacings';
import { GEL_MINION, GEL_FF_REITH_SANS } from '@bbc/gel-foundations/typography';
var Copyright = /*#__PURE__*/styled.p.attrs({
  role: 'text'
}).withConfig({
  displayName: "Copyright",
  componentId: "sc-11lgtw-0"
})(["", ";background-color:rgba(34,34,34,0.75);text-transform:uppercase;color:", ";padding:", " ", ";font-family:", ";position:absolute;bottom:0;margin:0;", ":0;"], GEL_MINION, C_WHITE, GEL_SPACING_HLF, GEL_SPACING, GEL_FF_REITH_SANS, function (props) {
  return props.position;
});
Copyright.propTypes = {
  position: oneOf(['left', 'right'])
};
Copyright.defaultProps = {
  position: 'left'
};
export default Copyright;